import "./welcomeWizard.scss";

import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";
import { withContainerContext } from "../container/ContainerContext";
import ModalCheckboxGrid from "../modal/ModalCheckboxGrid";
import WelcomeWizardTypeButton from "./WelcomeWizardTypeButton";

const renderTypeButtons = (types, onButtonClick) =>
  types.map(type => (
    <WelcomeWizardTypeButton
      key={type.label}
      icon={type.icon}
      iconColor={type.iconColor}
      disabled={type.disabled}
      label={type.label}
      onClick={() => onButtonClick(type.id)}
    />
  ));

const WelcomeWizardTypeButtonLayout = props => {
  return (
    <ModalCheckboxGrid
      columns={
        props.containerRect ? (props.containerRect.width < 350 ? 2 : props.containerRect.width < 500 ? 3 : 4) : 4
      }
    >
      {renderTypeButtons(props.types, props.onButtonClick)}
    </ModalCheckboxGrid>
  );
};

WelcomeWizardTypeButtonLayout.propTypes = {
  types: PropTypes.array.isRequired,
  onButtonClick: PropTypes.func.isRequired,

  // From containerContext
  containerRect: PropTypeShapes.flatRect
};

export default withContainerContext(WelcomeWizardTypeButtonLayout);
